var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{ref:"modal",staticClass:"c-modal l-modal",style:(_vm.positionStyle)},[_c(_vm.modal.component,_vm._b({tag:"component",on:{"close":_vm.hide}},'component',_vm.modal.props,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }